import React, { useState, Component } from "react";
import {
  StyleSheet,
  Keyboard,
  TextInput,
  TouchableOpacity,
} from "react-native";

import { Text, View, Input, Button } from "native-base";

import Modal from "modal-enhanced-react-native-web";

import { MyCart, Constant } from "./Data.js";
import * as firebase from "firebase";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();

export class AssistModal extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      restaurantID: props.restaurantID,
      tableID: props.tableID,
    };
  }

  onAssistSelected = (assist) => {
    const orderID = idGenerator();
    if (assist === "water") {
      db.collection("Restaurants")
        .doc(this.state.restaurantID)
        .collection("Orders")
        .doc(orderID)
        .set({
          timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
          table: this.state.tableID,
          tipAmount: 0,
          totalAmount: 0,
          subtotalAmount: 0,
          itemArray: ["Water"],
          orderID: orderID,
          donateTo: "1",
        });
    }
    if (assist === "human") {
      db.collection("Restaurants")
        .doc(this.state.restaurantID)
        .collection("Orders")
        .doc(orderID)
        .set({
          timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
          table: this.state.tableID,
          tipAmount: 0,
          totalAmount: 0,
          subtotalAmount: 0,
          itemArray: ["Human Assistance"],
          orderID: orderID,
          donateTo: "1",
        });
    }
    this.closeModal();
  };

  closeModal = () => {
    this.setState({ visible: false });
  };

  openModal = () => {
    this.setState({ visible: true });
  };

  render() {
    return (
      <Modal
        isVisible={this.state.visible}
        visible={this.state.visible}
        backdropColor="black"
        backdropOpacity={0.8}
        animationOut="slideOutDown"
        animationIn="bounceIn"
        avoidKeyboard={true}
        onBackdropPress={() => this.closeModal()}
        onBackButtonPress={() => this.closeModal()}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View style={{ flexDirection: "column", flex: 1 }}>
              <Text
                style={{
                  fontSize: 20,
                  fontFamily: Constant.font,
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                Assistance
              </Text>
              <View
                style={{
                  height: 60,
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.boxStyle2}
                  onPress={() => this.onAssistSelected("water")}
                >
                  <Text style={styles.textStyle2}>Ask for Water</Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  height: 60,
                  marginTop: 12,
                }}
              >
                <TouchableOpacity
                  style={styles.boxStyle}
                  onPress={() => this.onAssistSelected("human")}
                >
                  <Text style={styles.textStyle}>Ask for Human</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  centeredView: {
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 32,

    width: "90%",
  },
  textStyle: {
    fontFamily: Constant.font,
    fontSize: 16,
  },
  textStyle2: {
    fontFamily: Constant.font,
    fontSize: 16,
    color: "white",
    fontWeight: "bold",
  },
  boxStyle: {
    backgroundColor: Constant.gray,
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
  boxStyle2: {
    backgroundColor: Constant.color1,
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
});

function idGenerator() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}
